export default "__VITE_ASSET__A_NUYie6__"